import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ReviewOrderFilesModalComponent, ReviewOrderFilesModalData } from 'app/app-modules/modal';
import { firstValueFrom } from 'rxjs';
import { FileInfo, InProgressTreatment } from 'app/core/models';
import { getFileExtension } from 'app/core/utils';
import { FileExtensionToRenderer } from 'app/core/constants';

@Injectable()
export class ReviewOrderFilesModalService {
    private readonly _dialogService = inject(DialogService);

    open({ data }: { data: ReviewOrderFilesModalData }) {
        return firstValueFrom(
            this._dialogService.open(ReviewOrderFilesModalComponent, {
                data,
                width: '85vw',
                height: '90vh',
                showHeader: false,
                modal: true,
                closable: true,
                closeOnEscape: true,
                styleClass: 'modal-fill',
            }).onClose
        );
    }

    viewSingleFile(file: FileInfo, order: InProgressTreatment, hideSubType = false) {
        const extension = getFileExtension(file.name, true);
        const renderer = FileExtensionToRenderer[extension];
        if (renderer == null) return;

        return this.open({
            data: {
                renderer,
                files: [file],
                order,
                showApproveButton: false,
                productType: order.treatmentTypeId,
                showRequestRevisionButton: false,
                hideSubType,
            },
        });
    }
}
